import React from 'react';
import { Form, Header, Segment, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { fetchAcademicYears } from '../../Lookups/util';
import AcademicYear from './AcademicYear';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class StatisticsForProfessor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            professorId: '',
            studentsData: [],
            data: [],
            academicYears: [],
            academicYearId: '',

            loaded: false,
            loadedYears: false,
            loadedStudents: false

        };

        this.getGradesAndStudents = this.getGradesAndStudents.bind(this);
        this.getYearName = this.getYearName.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        axios.all([fetchAcademicYears()])
            .then(axios.spread((res) => {
                const academicYears = res.data.reverse().map((el, index) => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ academicYears, loadedYears: true, loadedStudents: true });
                axios.get('/academic-years/current')
                    .then(res => {
                        this.setState({ academicYearId: res.data.id }, () => { this.getGradesAndStudents(this.state.academicYearId); });
                    });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch academic years');
            });
    }

    getYearName(id) {
        const { academicYears } = this.state;
        const selected = academicYears.find(el => el.id === id);
        if (selected && selected.name) return selected.name;
        return '';
    }


    getGradesAndStudents(academicYearId) {
        axios.get(`/professor/grade-and-count/${academicYearId}`)
            .then(res => {
                const data = res.data.map((el, index) => ({
                    ...el,
                    yearId: this.getYearName(el.academicYear),
                    'Broj studenata': el.numberOfStudents,
                    'Prosječna ocjena': el.averageGrade
                }));
                this.setState({ data, loaded: true });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch average grades');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({ loaded: false });
        this.setState({
            [name]: value
        });
        this.setState({ loadedStudents: true });
        this.getGradesAndStudents(value);
    }


    render() {
        const { data } = this.state;
        return (
            <div>
                <Header as="h1"><FormattedMessage id="professorStatistics.statistics" /></Header>


                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            <FormattedMessage id="professorStatistics.selectAcademicYear" />
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field disabled={!this.state.loadedYears}>
                                    <label>                                                                                                                                                                                                                                                                                                                                                                                                                                                                     <FormattedMessage id="common.academicYear" /></label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder={<FormattedMessage id="professorStatistics.selectAcademicYear" />}
                                        value={this.state.academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>

                        </Form>
                    </Segment>
                </Segment.Group>
                {!this.state.loaded && this.state.loadedStudents ? <Loader active />
                    : this.state.loaded && <AcademicYear
                        data={data}
                        headerText={this.getYearName(this.state.academicYearId)}
                    />}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/StatisticsForProfessor/StatisticsForProfessor.js